import each from 'lodash/each';
import { getParams } from './common';
import TraceInit from '../TraceInit';

// 对iid编码
const handleIID = (iid) => {
  let newIId = '';
  each(iid, (v, k) => {
    if (typeof v === 'object') {
      v = JSON.stringify(v);
    }
    if (!newIId) {
      newIId = k + '=' + encodeURIComponent(v);
    } else {
      newIId += '&' + k + '=' + encodeURIComponent(v);
    }
  });
  return newIId;
};

export const getTraceData = (pageName, traceId, params = {}) => {
  const b = pageName || '';
  const ConfigData = TraceInit.getInstance().config[traceId] || {};
  const { operation = [] } = ConfigData;
  const c = getParams('c', ConfigData, params);
  const d = getParams('d', ConfigData, params) || 1;
  let iid = getParams('iid', ConfigData, params) || '';
  if (typeof iid === 'object') {
    iid = handleIID(iid);
  }
  // 对于oneTrack埋点的所需的配置解析
  let oneTrackParams = getParams('oneTrackParams', ConfigData, params) || {};
  const lowerType = operation.map((item) => item.toLowerCase());
  return { operation: lowerType, b, c, d, iid, oneTrackParams };
};

export const getTraceOperation = (traceId) => {
  const ConfigData = TraceInit.getInstance().config[traceId] || {};
  const lowerType =
    (Array.isArray(ConfigData?.operation) && ConfigData?.operation.map((item) => item.toLowerCase())) || [];
  return lowerType;
};

export const getSpm = (statSend, data, isTouch = false) => {
  const { spm } = statSend.getParam(
    {
      spm: data,
    },
    undefined,
    isTouch ? 'touch' : undefined,
  );
  return spm;
};

const ParseConfig = {
  getTraceData,
  getTraceOperation,
  getSpm, // 是根据getTraceOperation解析出来的结果为参数，经过操作，得出一个字符串
};

export default ParseConfig;
// export { getTraceData, getTraceOperation, getSpm };
